// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__17phC","bigColWidth":"Table_bigColWidth__2PWZL","biggerColWidth":"Table_biggerColWidth__1gui1","row":"Table_row__3En2T","col":"Table_col__1cLuQ"};